module.exports = __webpack_public_path__ + "static/img/defaultHead.2fc68ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head/defaultHead.png
// module id = DFpa
// module chunks = 6